import axios from 'axios';
import config from "../config";

export async function userLogin(username) {
  let res = {};
  axios.defaults.baseURL = config.servers["base"];
  const urlToLoad = `/login/login`;

  try {
    const response = await axios.post(
      urlToLoad,
      {
        "email": username,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    res = response.data;
    return res;
  } catch (error) {
    throw new Error('Login failed');
  }
}

export async function verifyOtp(username,opt) {
  let res = {};
  axios.defaults.baseURL = config.servers["base"];
  const urlToLoad = `/login/verify-otp/`;

  try {
    const response = await axios.post(
      urlToLoad,
      {
        "email": username,
        "otp": opt.toString(),
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    res = response.data;
    return res;
  } catch (error) {
    throw new Error('Login failed');
  }
}
